import { IconExcel, IconPdf, IconWord } from './icons';

export const GetIconDoc = (type: 'excel' | 'pdf' | 'word') => {
  switch (type) {
    case 'excel':
      return IconExcel;
    case 'pdf':
      return IconPdf;
    case 'word':
      return IconWord;
  }
};
